import { useState, useEffect } from 'react'

// 10 minutes and 43 seconds in seconds
const INITIAL_TIME = 10 * 60 + 43

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME)

  useEffect(() => {
    if (timeLeft <= 0) return

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(seconds).padStart(2, '0')

  return {
    timeLeft,
    formattedTime: `00:${formattedMinutes}:${formattedSeconds}`,
    isExpired: timeLeft <= 0,
  }
}
